import languages from './languages';
import type { Lucid } from '../../types/types';

/**
 * Accepts `langCode` of any of the accepted Lucid.I18n.LanguageFormats
 * @returns `languageKey`
 * @defaults `i18nKey`
 */
const formatLanguageKey = (langCode: string, returnFormat: Lucid.I18n.LanguageFormats = 'i18nKey'): string => {
  // Remove anything after comma (ex: 'Portuguese, Brazil')
  const trimLangCode = langCode.replace(/,.*/, '');
  const i18nLanguage = Object.values(languages).find(lang => Object.values(lang).find(val => val === trimLangCode));

  return (i18nLanguage && i18nLanguage[returnFormat]) || trimLangCode;
};

export default formatLanguageKey;
